// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__S0p-N","is-centered":"Loader_is-centered__3W-qj","bounce":"Loader_bounce__uTGPC","circle-bounce":"Loader_circle-bounce__--L9-"};